
/**
 * 获取 blob
 * @param  {String} url 目标文件地址
 * @return {Promise}
 */
function getBlob(url) {
    return new Promise(resolve => {
        const xhr = new XMLHttpRequest();

        xhr.open("GET", url, true);
        xhr.responseType = "blob";
        xhr.onload = () => {
            if (xhr.status === 200) {
                resolve(xhr.response);
            }
        };
        xhr.onerror = () => {
            // 处理跨域或网络错误
            console.error("下载文件时发生错误:", url);
            resolve(null);
        };
        try {
            xhr.send();
        } catch (error) {
            console.error("发送请求时发生错误:", error);
            resolve(null);
        }
    });
}

/**
 * 保存
 * @param  {Blob} blob
 * @param  {String} filename 想要保存的文件名称
 */
function saveAs(blob, filename) {
    if (!blob) {
        console.error("无效的blob对象");
        return;
    }

    if (window.navigator.msSaveOrOpenBlob) {
        navigator.msSaveBlob(blob, filename);
    } else {
        const link = document.createElement("a");
        const body = document.querySelector("body");

        link.href = window.URL.createObjectURL(blob);
        link.download = filename;

        // fix Firefox
        link.style.display = "none";
        body.appendChild(link);

        link.click();
        body.removeChild(link);

        window.URL.revokeObjectURL(link.href);
    }
}

/**
 * 下载
 * @param  {String} url 目标文件地址
 * @param  {String} filename 想要保存的文件名称
 */
export const download = (url, filename) => {
    // 处理HTTP链接在HTTPS页面中的情况
    if (window.location.protocol === 'https:' && url.startsWith('http:')) {
        // 对于跨域或协议不匹配的情况，使用替代方案
        console.warn("检测到混合内容，尝试使用替代下载方法:", url);
        downloadURL(url);
        return;
    }

    const loading = window.ElementUI.Loading.service({
        lock: false,
        text: !localStorage.lang || localStorage.lang == 'zh' ? '下载中，请稍候...' : 'Downloading... Please wait a moment...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.1)'
    });
    getBlob(url).then(blob => {
        if (blob) {
            saveAs(blob, filename);
        } else {
            // 如果blob获取失败，尝试使用替代方法
            downloadURL(url);
        }
        loading.close();
    }).catch(error => {
        loading.close();
        console.error("下载过程中发生错误:", error);
        // 出现错误时也尝试使用替代方法
        downloadURL(url);
    });
};

/**
 * 下载
 * @param  {String} url 目标文件地址
 * @param  {String} filename 想要保存的文件名称
 */
export const downloadURL = (url) => {
    // 创建一个隐藏的iframe来处理下载
    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    document.body.appendChild(iframe);

    // 在iframe中打开链接
    iframe.contentWindow.location.href = url;

    // 几秒后移除iframe
    setTimeout(() => {
        document.body.removeChild(iframe);
    }, 1000);
};

// These helpers produce better VM code in JS engines due to their
// explicitness and function inlining.
export const isUndef = v => {
    return v === undefined || v === null;
};
export const isDef = v => {
    return v !== undefined && v !== null;
};
export const isTrue = v => {
    return v === true;
};
export const isFalse = v => {
    return v === false;
};
/**
 * Convert a value to a string that is actually rendered.
 */
export const toString = val => {
    return val == null ?
        "" :
        Array.isArray(val) || (isPlainObject(val) && val.toString === _toString) ?
            JSON.stringify(val, null, 2) :
            String(val);
};
/**
 * Convert an input value to a number for persistence.
 * If the conversion fails, return original string.
 */
export const toNumber = val => {
    var n = parseFloat(val);
    return isNaN(n) ? val : n;
};

/**
 * Remove an item from an array.
 */
export const remove = (arr, item) => {
    if (arr.length) {
        var index = arr.indexOf(item);
        if (index > -1) {
            return arr.splice(index, 1);
        }
    }
};
/**
 * Check whether an object has the property.
 */
export const hasOwn = (obj, key) => {
    let hasOwnProperty = Object.prototype.hasOwnProperty;
    return hasOwnProperty.call(obj, key);
};
/**
 * Merge an Array of Objects into a single Object.
 */
export const toObject = arr => {
    var res = {};
    for (var i = 0; i < arr.length; i++) {
        if (arr[i]) {
            extend(res, arr[i]);
        }
    }
    return res;
};
/**
 * Removing Duplicate Elements from Arrays
 */
export const deteleObject = obj => {
    var uniques = [];
    var stringify = {};
    for (var i = 0; i < obj.length; i++) {
        var keys = Object.keys(obj[i]);
        keys.sort(function (a, b) {
            return Number(a) - Number(b);
        });
        var str = "";
        for (var j = 0; j < keys.length; j++) {
            str += JSON.stringify(keys[j]);
            str += JSON.stringify(obj[i][keys[j]]);
        }
        if (!stringify.hasOwnProperty(str)) {
            uniques.push(obj[i]);
            stringify[str] = true;
        }
    }
    uniques = uniques;
    return uniques;
};

export const format = function (fmt) {
    var o = {
        "M+": this.getMonth() + 1, //月份
        "d+": this.getDate(), //日
        "h+": this.getHours(), //小时
        "m+": this.getMinutes(), //分
        "s+": this.getSeconds(), //秒
        "q+": Math.floor((this.getMonth() + 3) / 3), //季度
        S: this.getMilliseconds() //毫秒
    };
    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(
            RegExp.$1,
            (this.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
    }
    for (var k in o) {
        if (new RegExp("(" + k + ")").test(fmt)) {
            fmt = fmt.replace(
                RegExp.$1,
                RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length)
            );
        }
    }
    return fmt;
};
export const toJSON = () => {
    return this.format("yyyy-MM-dd hh:mm:ss"); // util.formatDate是自定义的个时间格式化函数
};